import React, { useState } from "react";
import {
  Button,
  CustomInput,
  FormFieldSet,
  InfoCardNewAdv,
  InfoWrapper,
  PageTitle,
  SmartTooltip,
  TableAdv,
  useFormHandler,
} from "../../../../../../../components";
import { mapTableRows } from "../../../../../../../utils";

const DeductionReceivePayment = ({ onClose }) => {
  const [selectedDeductions, setSelectedDeductions] = useState([]);
  const initialFormData = {
    employee: "",
    paymentDate: "",
    paymentMethod: "",
    referenceNumber: "",
    depositTo: "",
    attachment: "",
    inrAmount: "",
    exchangeAmount: "",
    amountReceived: "",
    freezeAmount: [],
  };
  const { formData, errors, handleChange } = useFormHandler(
    initialFormData,
    {},
  );

  const [tabledata, setTableData] = useState([
    {
      id: 1,
      description: "H1B CASE 2022",
      installments: "9/10",
      orinalAmount: "10,000",
      openBalance: "1000",
      payment: "900",
    },
    {
      id: 2,
      description: "H1B CASE 2022",
      installments: "9/10",
      orinalAmount: "10,000",
      openBalance: "1000",
      payment: "1000",
    },
    {
      id: 3,
      description: "H1B CASE 2022",
      installments: "9/10",
      orinalAmount: "10,000",
      openBalance: "1000",
      payment: "1000",
    },
  ]);
  const intialduecolumns = [
    {
      key: "description",
      label: "Description",
      render: (row) => (
        <SmartTooltip
          description={row?.description}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.description}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "installments",
      label: "Installments",
      render: (row) => (
        <SmartTooltip
          description={row?.installments}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.installments}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "orinalAmount",
      label: "Original Amount",
      render: (row) => (
        <SmartTooltip
          description={row?.orinalAmount}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.orinalAmount}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "openBalance",
      label: "Open Balance",
      render: (row) => (
        <SmartTooltip
          description={row?.openBalance}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.openBalance}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "payment",
      label: "Payment",
      render: (row) => (
        <div>
          <CustomInput
            type="text"
            size="xs"
            value={row?.payment === "-" ? "" : row?.payment}
            disabled={formData?.freezeAmount?.includes("true")}
            onChange={(e) => handleChangeTable("payment", row, e)}
          />
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(tabledata, intialduecolumns);
  const handleChangeTable = (field, row, value) => {
    setTableData((prev) =>
      prev?.map((item) =>
        item?.id === row?.id ? { ...item, [field]: value } : item,
      ),
    );
  };

  return (
    <div>
      {/* Summary Cards */}
      <div className="flex justify-end gap-3">
        <InfoWrapper className={"min-w-[220px]! max-w-[250px]!"}>
          <InfoCardNewAdv
            title={"Amount Received:"}
            value={10}
            prefix="$"
            layout="option3"
            layoutConfig={{
              layoutClassName: "flex justify-start! text-nowrap!",
            }}
            bgConfig={{
              className:
                "flex justify-start! text-nowrap! bg-success-50! rounded-lg! border-success!",
            }}
            prefixConfig={{ className: "text-black! text-[15px]!" }}
            valueConfig={{ className: "text-black! text-[15px]!" }}
            titleConfig={{ className: "text-black!" }}
          />

          <InfoCardNewAdv
            title={"Pending Balance:"}
            value={5}
            prefix="$"
            layout="option3"
            layoutConfig={{
              layoutClassName: "flex justify-start! text-nowrap!",
            }}
            prefixConfig={{ className: "text-black! text-[15px]!" }}
            valueConfig={{ className: "text-black! text-[15px]!" }}
            titleConfig={{ className: "text-black!" }}
            bgConfig={{
              className:
                "flex justify-start! text-nowrap! bg-danger-50! rounded-lg! border-danger!",
            }}
          />
        </InfoWrapper>
      </div>

      {/* Employee */}
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-6 max-w-5xl mt-4">
        <FormFieldSet
          type="text"
          title="Employee"
          placeholder="Select Employee"
          value={formData?.employee}
          onChange={(value) => handleChange("employee", value)}
          disabled
        />
      </div>

      {/* Payment Date */}
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-6 max-w-5xl mt-4">
        <FormFieldSet
          type="datepicker"
          title="Payment Date"
          placeholder="MM/DD/YYYY"
          value={formData?.paymentDate}
          onChange={(value) => handleChange("paymentDate", value)}
          error={errors?.paymentDate}
          showDropdown={false}
        />

        <div className="mt-5">
          <Button
            title="Show Unpaid Timesheets"
            type="button"
            variant="outlined"
            size="md"
          />
        </div>
      </div>

      {/* Payment Info */}
      <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-6 max-w-5xl mt-4">
        <FormFieldSet
          type="select"
          title="Payment Method"
          placeholder="Select Payment Method"
          value={formData?.paymentMethod}
          onChange={(value) => handleChange("paymentMethod", value)}
          error={errors?.paymentMethod}
          options={[
            { label: "Bank Transfer", value: "bank" },
            { label: "Cash", value: "cash" },
            { label: "Cheque", value: "cheque" },
          ]}
        />

        <FormFieldSet
          type="text"
          title="Reference Number"
          placeholder="Enter Reference Number"
          value={formData?.referenceNumber}
          onChange={(value) => handleChange("referenceNumber", value)}
          error={errors?.referenceNumber}
        />

        <FormFieldSet
          type="text"
          title="Deposit To"
          placeholder="Select Deposit To"
          value={formData?.depositTo}
          onChange={(value) => handleChange("depositTo", value)}
          error={errors?.depositTo}
        />

        <FormFieldSet
          type="file"
          title="Attachment"
          placeholder="Choose File"
          value={formData?.attachment}
          onChange={(value) => handleChange("attachment", value)}
          error={errors?.attachment}
        />

        <FormFieldSet
          type="text"
          title="INR Amount"
          placeholder="Enter INR Amount"
          value={formData?.inrAmount}
          onChange={(value) => handleChange("inrAmount", value)}
          error={errors?.inrAmount}
        />

        <FormFieldSet
          type="text"
          title="Exchange Amount"
          placeholder="Enter Exchange Amount"
          value={formData?.exchangeAmount}
          onChange={(value) => handleChange("exchangeAmount", value)}
          error={errors?.exchangeAmount}
        />

        <FormFieldSet
          type="text"
          title="Amount Received"
          placeholder="Enter Amount Received"
          value={formData?.amountReceived}
          onChange={(value) => handleChange("amountReceived", value)}
          error={errors?.amountReceived}
        />

        <FormFieldSet
          type="checkbox"
          size="md"
          title=" "
          options={[
            {
              label: "Freeze Amount",
              value: "true",
            },
          ]}
          values={formData?.freezeAmount}
          onChange={(value) => handleChange("freezeAmount", value)}
        />
      </div>
      <div className="my-6 border border-gray-300 bg-gray-200 py-1 px-5 rounded-lg">
        OutStanding Transactions
      </div>
      <div className={`mt-5`}>
        <TableAdv
          columns={intialduecolumns}
          rows={mappedRows}
          serverPagination={false}
          showCheckbox
          defaultSelectedRows={selectedDeductions}
          onSelectionChange={setSelectedDeductions}
          // disableSelection={formData?.freezeAmount == "true"}
        />
      </div>
      <div className="bg-gray-50 rounded-lg py-2 flex gap-5 p-8 justify-end mt-5 border border-gray-300 ">
        <div className="flex">
          <div className="flex-1 items-end">
            <PageTitle title={"Received Amount : "} tag="span" />{" "}
          </div>
          <div className="flex pl-1">
            <PageTitle title={`$${5}`} tag="span" />
          </div>
        </div>
        <div className="flex">
          <div className="flex-1 items-end">
            <PageTitle title={"Selected Amount :"} tag="span" />
          </div>
          <div className="flex pl-1">
            <PageTitle title={`$${10}`} tag="span" />
          </div>
        </div>
        <div className="flex">
          <div className="flex-1 items-end">
            <PageTitle title={"Difference Amount :"} tag="span" />
          </div>
          <div className="flex pl-1">
            <PageTitle title={`$${15}`} tag="span" />
          </div>
        </div>
      </div>
      <div className="flex justify-end gap-3 mt-8">
        <Button title={"Cancel"} variant="outlined" onClick={onClose} />
        <Button title="Save" />
      </div>
    </div>
  );
};

export default DeductionReceivePayment;
